import { nonEmptyString } from 'schemas/common';
import { z } from 'zod';

export const subjectSchema = z.object({
  ID: nonEmptyString,
  code: nonEmptyString,
  creditPoints: z.number().min(0),
  name: nonEmptyString,
  unspecified: z.boolean(),
});
